import clsx from "clsx";
import type { Ref } from "react";

export function UnavailablePeriodNote({
  note,
  size,
  backgroundClass = "bg-dx-surface-subtle",
  sectionRef,
}: {
  note: string;
  size: "large" | "small";
  backgroundClass?: string;
  sectionRef: Ref<HTMLDivElement>;
}) {
  return (
    <div
      ref={sectionRef}
      className={size === "small" ? "px-[8px] py-[8px]" : "px-[12px] py-[12px]"}
    >
      <p
        className={clsx(
          backgroundClass,
          "text-dx-text-sub rounded-[6px] px-[14px] py-[10px] text-[13px] leading-[20px] font-bold",
        )}
      >
        {note}
      </p>
    </div>
  );
}
